<div class="flex gap-2">
  @if (hasMultiImageDownload) {
    <button
      (click)="toggleMultiImageDownload.emit()"
      [title]="
      multiImageDownloadActive
        ? ('catalog.result_list.disable_multi_image_download' | transloco)
        : ('catalog.result_list.enable_multi_image_download' | transloco)
    "
      id="catalog_result_btn_toggle-multi-image-download"
      [ngClass]="[multiImageDownloadActive ? 'primary-fab' : 'error-fab']"
      mat-mini-fab
    >
      <mat-icon [class.fill]="multiImageDownloadActive">cloud_download</mat-icon>
    </button>
  }

  <button
    (click)="clear.emit()"
    [title]="'catalog.result.delete_result_items' | transloco"
    class="error-fab"
    id="catalog_result_btn_delete-all-tabs"
    mat-mini-fab
  >
    <mat-icon>delete</mat-icon>
  </button>
</div>
